import { useState } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { Flag } from "semantic-ui-react";

// type LanguageOption = {
//   value: string;
//   label: JSX.Element;
// };

const MobileMenu = (logo: any) => {
  const [activeMenu, setActiveMenu] = useState("");
  const [isClicked, setIsclicked] = useState(false);

  const activeMenuSet = (value: any) =>
      setActiveMenu(activeMenu === value ? "" : value),
    activeLi = (value: any) =>
      value === activeMenu ? { display: "block" } : { display: "none" };

    // const { i18n } = useTranslation();
    const { t } = useTranslation();
  
    // const languages: LanguageOption[] = [
    //   {
    //     value: "en",
    //     label: (
    //       <div style={{ display: "flex", alignItems: "center", color: "#000" }}>
    //         <Flag name="vg" /> En
    //       </div>
    //     ),
    //   },
    //   {
    //     value: "az",
    //     label: (
    //       <div style={{ display: "flex", alignItems: "center", color: "#000" }}>
    //         <Flag name="az" /> Az
    //       </div>
    //     ),
    //   },
    //   {
    //     value: "ar",
    //     label: (
    //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
    //         <Flag name="ae" /> Ae
    //       </div>
    //     ),
    //   },
    //   {
    //     value: "ru",
    //     label: (
    //       <div style={{ display: "flex", alignItems: "center", color: "#fff" }}>
    //         <Flag name="ru" /> Ru
    //       </div>
    //     ),
    //   },
    // ];
  
 
    // const [activeLang, setActiveLang] = useState<string>("en");



    // const handleLangChange = (selectedOption: any) => {
    //   setActiveLang(selectedOption.value);
    //   i18n.changeLanguage(selectedOption.value);
    // };
  return (
    <nav className="main-menu navbar-expand-lg d-block d-lg-none mobile-header">
      <Accordion>
        <div className="navbar-header">
          <div className="mobile-logo my-15">
            <Link to="/">
             
                <img
                  src={"/assets/tth_logo.png"}
                  alt="Logo"
                  title="Logo"
                  style={{ height: "35px", width: "auto" }}
                />
              
            </Link>
          </div>


          {/* <div className="d-flex justify-content-center align-items-center me-2">
          <Select
            value={languages.find((lang) => lang.value === activeLang)}
            onChange={handleLangChange}
            options={languages}
            isSearchable={false}
          />
        </div> */}
          {/* Toggle Button */}
          <div className="menu-sidebar d-block d-lg-none">
            <button onClick={() => setIsclicked(!isClicked)}>
              <span className="icon-bar" style={{ backgroundColor: "#000" }} />
              <span className="icon-bar" style={{ backgroundColor: "#000" }} />
              <span className="icon-bar" style={{ backgroundColor: "#000" }} />
            </button>
          </div>
        </div>
        <Accordion.Collapse
          eventKey="nav"
          className="navbar-collapse clearfix"
          style={{ display: `${isClicked ? "block" : "none"}` }}
        >
          <ul className="navigation clearfix">
            <li className="dropdown">
              <Link to="/">{t("navHome")}</Link>
            </li>
            <li className="dropdown">
              <a href="/">{t("navServices")}</a>
              <ul style={activeLi("services")}>
                <li>
                  <Link to="/web-development">{t("navServicesSub1")}</Link>
                </li>
                <li>
                  <Link to="/mobile-app-development">
                  {t("navServicesSub2")}
                  </Link>
                </li>
                <li>
                  <Link to="/software-development">{t("navServicesSub3")}</Link>
                </li>
                <li>
                  <Link to="/dev-ops">{t("navServicesSub4")}</Link>
                </li>
                <li>
                  <Link to="/cloud-computing">{t("navServicesSub5")}</Link>
                </li>
                <li>
                  <Link to="/digital-marketing">{t("navServicesSub6")}</Link>
                </li>
              </ul>
              <div
                className="dropdown-btn"
                onClick={() => activeMenuSet("services")}
              >
                <span className="fas fa-chevron-down" />
              </div>
            </li>
           <li className="dropdown">
  <Link to="#" onClick={(e) => e.preventDefault()}>Solutions</Link>
  <ul style={activeLi("solutions")}>
    <li><Link to="/projects">Projects</Link></li>
    <li><Link to="/cloud-adoption">Cloud Adoption</Link></li>
    <li><Link to="/process-integration">Process Integration</Link></li>
    <li><Link to="/manufacturing-execution">Manufacturing Execution</Link></li>
    <li><Link to="/industrial-iot">Industrial IoT</Link></li>
    <li><Link to="/systems-of-engagement">Systems of Engagement</Link></li>
    <li><Link to="/customer-experience">Customer Experience</Link></li>
  </ul>
  <div
    className="dropdown-btn"
    onClick={() => activeMenuSet("solutions")}
  >
    <span className="fas fa-chevron-down" />
  </div>
</li>
            <li className="dropdown">
              <Link to="/about-us">{t("navAbout")}</Link>
            </li>
            
            <li>
                      <Link to="/press-release">{t("navPress")}</Link>
              </li>
               <li className="dropdown">
  <Link to="#" onClick={(e) => e.preventDefault()}>Blogs</Link>
  <ul style={activeLi("blogs")}>
    <li><Link to="/blogs">Blog</Link></li>
    <li><Link to="/case-studies">Case Studies</Link></li>
  </ul>
  <div
    className="dropdown-btn"
    onClick={() => activeMenuSet("blogs")}
  >
    <span className="fas fa-chevron-down" />
  </div>
</li>
            <li>
              <Link to="/contact-us">{t("navContact")}</Link>
            </li>
          </ul>
        </Accordion.Collapse>
      </Accordion>
    </nav>
  );
};
export default MobileMenu;
